import { Injectable } from "@angular/core";

import { NoxiousInvasiveSearchCriteria } from "@models/NoxiousInvasiveSearchCriteria";

import { PlantsService } from "./plants.service";

@Injectable()
export class NoxiousInvasiveSearchResolver {
  constructor(private ps: PlantsService) {}

  async resolve(): Promise<NoxiousInvasiveSearchCriteria> {
    const criteria = await this.ps.getNoxiousInvasiveSearchCriteria();
    return criteria;
  }
}
